<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Новая Корпорация / Компания
            </div>
            <div class="content-inner">
                <!-- --- --->
                <div class="header-for-input">ИНН</div>
                <input type="text" class="content-input input_width_50" v-model="company.inn" />
                <div class="btn_main_button btn_search_in_dadata" @click="get_dadata_data">Поиск по ИНН в сервисе Dadata</div>
                <!-- --- --->
                <div class="header-for-input">Полное наименование компании</div>
                <input type="text" class="content-input input_width_50" v-model="company.full_name" />
                <!-- --- --->
                <div class="header-for-input">Краткое наименование</div>
                <input type="text" class="content-input input_width_50" v-model="company.short_name" />
                <!-- --- --->
                <div class="header-for-input">Юридический адрес</div>
                <input type="text" class="content-input input_width_50" v-model="company.address" />
                <!-- --- --->
                <div class="header-for-input">Регион</div>
                <select class="content-input input_width_50" v-model="company.region_id" @change="get_ref_cities()">
                    <option value="0">Не выбрано</option>
                    <option v-for="region in ref_regions" :key="region.id" :value="region.id">{{region.name}}</option>
                </select>
                <!-- --- --->
                <div class="header-for-input">Город</div>
                <select class="content-input input_width_50" v-model="company.city_id">
                    <option value="0">Не выбрано</option>
                    <option v-for="city in ref_cities" :key="city.id" :value="city.id">{{city.name}}</option>
                </select>
                <!-- --- --->
                <div class="header-for-input">Основной ОКВЭД</div>
                <input v-maska="'##.##.##'" type="text" class="content-input input_width_50" v-model="company.okved" placeholder="00.00.00" />
                
                <!-- --- --->
                <div class="header-for-input">Примерная численность сотрудников</div>
                <input type="number" class="content-input input_width_50" v-model="company.count_of_emploies" />
                <!-- --- --->
                <div class="header-for-input">Выручка за последний год (тыс. руб.)</div>
                <input type="number" class="content-input input_width_50" v-model="company.proceeds" />
                <!-- --- --->
                <div class="header-for-input">Входит в структуру Гос. корпорации</div>
                <select class="content-input input_width_50" v-model="company.isGosCorp">
                    <option value="0">Нет</option>
                    <option value="1">Да</option>
                </select>
                <div class="btn_main_button" @click="new_company">Сохранить</div>
            </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'NewCompany',
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            company: {
                full_name: '', // +
                short_name: '', // +
                inn: '', // +
                address: '', // + 
                region_id: 0,
                city_id: 0,
                okved: '', 
                count_of_emploies: '',
                proceeds: '',
                isGosCorp: ''
            },
            ref_regions: {},
            ref_cities: {},
        }
    },
    methods: {
        get_ref_regions() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/refbook/regions')
            .then(response => {
                this.ref_regions = response.data.data  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        get_ref_cities() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/refbook/cities/'+this.company.region_id)
            .then(response => {
                this.ref_cities = response.data.data  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        new_company() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/company', {
                full_name: this.company.full_name,
                short_name: this.company.short_name,
                inn: this.company.inn,
                address: this.company.address,
                region_id: this.company.region_id,
                city_id: this.company.city_id,
                okved: this.company.okved,
                count_of_emploies: this.company.count_of_emploies,
                proceeds: this.company.proceeds,
                isGosCorp: this.company.isGosCorp
            })
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        get_dadata_data() {
            let loader = this.$loading.show()
            this.$http.defaults.headers.common['Authorization'] = 'Token ' + 'bfaf61d49976991221a3e7e93e873495e30d1011';
            this.$http.defaults.headers.common['Content-Type'] = 'application/json';
            this.$http.defaults.headers.common['Accept'] = 'application/json';
            this.$http.post('https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party', {
            query: this.company.inn
            })
            .then(response => {
                let dadataanswer = response.data;
                if(dadataanswer != null) {
                    this.company.full_name = dadataanswer.suggestions[0].unrestricted_value
                    this.company.short_name = dadataanswer.suggestions[0].value
                    this.company.address = dadataanswer.suggestions[0].data.address.unrestricted_value
                    this.company.okved = dadataanswer.suggestions[0].data.okved
                    this.company.count_of_emploies = dadataanswer.suggestions[0].data.employee_count
                }
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
            });
        }
    },
    created() {
        this.get_ref_regions()
    }

}
</script>

<style scoped>
    .btn_search_in_dadata {
        width: fit-content !important;
        padding-left: 10px;
        padding-right: 10px;
    }
</style>
<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>